import { render, staticRenderFns } from "./Postback.vue?vue&type=template&id=81f7022c"
import script from "./Postback.vue?vue&type=script&lang=ts"
export * from "./Postback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_cache-loader@4.1.0_webpack@4.47.0__css-load_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports